import React, { useState, useRef, useEffect } from 'react';
import { ChevronLeft, ChevronRight} from 'lucide-react';
import './Services.css';
import PageWrapper from "../PageWrapper";

import sbg1 from '../../Assets/sbg1.png';
import sbg2 from '../../Assets/sbg2.png';
import sbg3 from '../../Assets/sbg3.png';
import sbg4 from '../../Assets/sbg4.png';
import sbg5 from '../../Assets/sbg5.png';
import sbg6 from '../../Assets/sbg6.png';
import sbg7 from '../../Assets/sbg7.png';
import sbg8 from '../../Assets/sbg8.png';
import sbg9 from '../../Assets/sbg9.png';
import sbg10 from '../../Assets/sbg10.png';
import sbg11 from '../../Assets/sbg11.png';
import sbg12 from '../../Assets/sbg12.png';

const services = [
  {
    id: 1,
    img: sbg1,
    title: "Assurance & Business Consultancy",
    text: "Financial assurance and management consultancy services."
  },
  {
    id: 2,
    img: sbg2,
    title: "Tax Advisory Services",
    text: "Corporate and personal tax advisory and compliance."
  },
  {
    id: 3,
    img: sbg3,
    title: "Corporate Secretarial Services",
    text: "We are handling the Company Secretarial matters through our subsidiary company 'Colombo Secretaries (Pvt.) Ltd' and services include company incorporations, Annual Return handling, and other legal matters related to the Register of Companies."
  },
  {
    id: 4,
    img: sbg4,
    title: "Business Process Reengineering",
    text: "Technology is rapidly changing and business processes are becoming outdated with these changes. exposing companies to trouble. VTAS helps to reengineer business processes with generally accepted best practices in the world."
  },
  {
    id: 5,
    img: sbg5,
    title: "HR management and Payroll services",
    text: "We handle your payroll matters and other Human Capital Management functions while you are focusing on your main business. This includes all statutory payments, reporting, and employee documentation."
  },
  {
    id: 6,
    img: sbg6,
    title: "Inventory Verifications",
    text: "We handle the periodic stock verification processes of our customers island-wide. VTAS maintains a team of experts and other staff members required for counting inventory items and provides reports for management and audits."
  },
  {
    id: 7,
    img: sbg7,
    title: "Management Consultancy",
    text: "We are doing management consultancy services for our customers."
  },
  {
    id: 8,
    img: sbg8,
    title: "Book Keeping Services",
    text: "Maintaining accurate daily transaction records is essential for assessing business performance and meeting statutory requirements. VTAS offers expert bookkeeping services using modern, cloud-based technology to ensure reliable, validated reports."
  },
  {
    id: 9,
    img: sbg9,
    title: "Enterprise Resource Planning Supports and Implementations",
    text: "VTAS is having experts in ERP implementations and is ready to provide ERP implementation-related support for the customer at a lower rate. This includes project management, Business Process Re-engineering, ERP vendor selections, preparing RFQ documents, Support to identify the process requirements, Final evaluation process."
  },
  {
    id: 10,
    img: sbg10,
    title: "Risk Advisory",
    text: "We do internal audit functions and help organizations to identify the risk associated with their business processes. VTAS helps to identify the controls required to mitigate those risk factors."
  },
  {
    id: 11,
    img: sbg11,
    title: "DATA Entry Services",
    text: "In today's context, accurate information is the key to business success. It is very vital to make sure the data input is accurate and reliable to get the correct output. VTAS provides reliable data entry services online or onsite based on customer preference."
  },
  {
    id: 12,
    img: sbg12,
    title: "Feasibility Studies and Project Reports for banks and other financial institutions",
    text: "Our team is handling the financial feasibility studies, Project Reports required by banks or other financial institutes when you apply financial solutions."
  }
];

const Services = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [cardsPerView, setCardsPerView] = useState(4);
  const [showArrows, setShowArrows] = useState(false);
  const [isAutoScrolling, setIsAutoScrolling] = useState(true);
  const [selectedService, setSelectedService] = useState(null);
  const scrollContainerRef = useRef(null);
  const autoScrollIntervalRef = useRef(null);

  const cardWidth = 420;

  useEffect(() => {
    const updateDimensions = () => {
      if (scrollContainerRef.current) {
        const containerWidth = scrollContainerRef.current.offsetWidth;
        const visibleCards = Math.floor(containerWidth / cardWidth);
        setCardsPerView(Math.max(1, visibleCards));
        setShowArrows(services.length > visibleCards);
      }
    };

    updateDimensions();
    window.addEventListener('resize', updateDimensions);
    return () => window.removeEventListener('resize', updateDimensions);
  }, []);

  const maxIndex = Math.max(0, services.length - cardsPerView);
  const totalDots = maxIndex + 1;

  const scrollToIndex = (index) => {
    if (scrollContainerRef.current) {
      const scrollPosition = index * cardWidth;
      scrollContainerRef.current.scrollTo({
        left: scrollPosition,
        behavior: 'smooth'
      });
    }
  };

  // Auto-scroll functionality
  useEffect(() => {
    if (isAutoScrolling) {
      autoScrollIntervalRef.current = setInterval(() => {
        setCurrentIndex((prevIndex) => {
          const nextIndex = prevIndex >= maxIndex ? 0 : prevIndex + 1;
          scrollToIndex(nextIndex);
          return nextIndex;
        });
      }, 3000);

      return () => {
        if (autoScrollIntervalRef.current) {
          clearInterval(autoScrollIntervalRef.current);
        }
      };
    }
  }, [isAutoScrolling, maxIndex]);

  const handlePrevious = () => {
    setIsAutoScrolling(false);
    const newIndex = Math.max(0, currentIndex - 1);
    setCurrentIndex(newIndex);
    scrollToIndex(newIndex);
  };

  const handleNext = () => {
    setIsAutoScrolling(false);
    const newIndex = Math.min(maxIndex, currentIndex + 1);
    setCurrentIndex(newIndex);
    scrollToIndex(newIndex);
  };

  const handleScroll = () => {
    if (scrollContainerRef.current) {
      const scrollLeft = scrollContainerRef.current.scrollLeft;
      const newIndex = Math.round(scrollLeft / cardWidth);
      setCurrentIndex(Math.min(newIndex, maxIndex));
    }
  };

  const handleDotClick = (index) => {
    setIsAutoScrolling(false);
    setCurrentIndex(index);
    scrollToIndex(index);
  };

  const handleMouseEnter = () => {
    setIsAutoScrolling(false);
  };

  const handleMouseLeave = () => {
    setIsAutoScrolling(true);
  };

  const openModal = (service) => {
    setSelectedService(service);
    setIsAutoScrolling(false);
  };

  const closeModal = () => {
    setSelectedService(null);
    setIsAutoScrolling(true);
  };

  return (
    <PageWrapper>
    <div 
      className="services-wrapper"
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <h2 className="services-heading">Our Services</h2>
      <p className="services-subtitle">We provide smart and reliable solutions</p>

      <div className="services-carousel-wrapper">
        {showArrows && (
          <button
            onClick={handlePrevious}
            disabled={currentIndex === 0}
            className={`nav-btn left ${currentIndex === 0 ? 'disabled' : ''}`}
          >
            <ChevronLeft size={32} />
          </button>
        )}

        <div 
          ref={scrollContainerRef}
          onScroll={handleScroll}
          className="services-cards-container"
        >
          {services.map((service) => (
            <div 
              key={service.id} 
              className="service-card"
              onMouseEnter={(e) => e.currentTarget.classList.add('hovered')}
              onMouseLeave={(e) => e.currentTarget.classList.remove('hovered')}
            >
              <div className="service-image-container">
                <img src={service.img} alt={service.title} className="service-icon" />
              </div>
              <div className="service-card-content">
                <h3 className="service-card-title">{service.title}</h3>
                <p className="service-card-text">{service.text}</p>
                <button
                  onClick={() => openModal(service)}
                  className="read-more"
                >
                  Read more →
                </button>
              </div>
            </div>
          ))}
        </div>

        {showArrows && (
          <button
            onClick={handleNext}
            disabled={currentIndex === maxIndex}
            className={`nav-btn right ${currentIndex === maxIndex ? 'disabled' : ''}`}
          >
            <ChevronRight size={32} />
          </button>
        )}
      </div>

      {totalDots > 1 && (
        <div className="dot-indicators">
          {Array.from({ length: totalDots }, (_, index) => (
            <button
              key={index}
              onClick={() => handleDotClick(index)}
              className={`dot ${currentIndex === index ? 'active' : ''}`}
            />
          ))}
        </div>
      )}

      {/* Modal for Read More */}
      {selectedService && (
        <div className="modal-overlay" onClick={closeModal}>
          <div className="modal-box" onClick={e => e.stopPropagation()}>
            {/* <button className="modal-close" style={{ marginLeft: '15px' }} onClick={closeModal}>
              <X size={30} />
            </button> */}
            <div className="modal-image">
              <img src={selectedService.img} alt={selectedService.title} />
            </div>
            <div className="modal-content">
              <h3 className="modal-title">{selectedService.title}</h3>
              <p className="modal-description">{selectedService.text}</p>
              <button className="modal-action" onClick={closeModal}>Close</button>
            </div>
          </div>
        </div>
      )}
    </div>
    </PageWrapper>
  );
};

export default Services;